import * as React from "react";
import { createValidator } from "not-valid";
import * as moment from "moment";

export const timeIsAfter = (value: moment.Moment, isAfterDate: moment.Moment) => {
    return value.diff(isAfterDate) >= 0;
};

export const useTimeIsAfterValidator = (isAfterDate: moment.Moment) => {
    const validator = React.useMemo(
        () => createValidator((value: moment.Moment) => timeIsAfter(value, isAfterDate), `Must be after ${isAfterDate.format("DD/MM/YYYY")}`),
        [isAfterDate]);
    return validator;
};
